export enum TIPO_ORIGEN {
  EXTRAJUDICIAL = 'Extrajudicial',
  JUDICIAL = 'Judicial'
}

export const TOGGLE_BUTTON_DEFAULT_VALUE = 'No'

export const TIPO_ORIGEN_OPTIONS = [TIPO_ORIGEN.JUDICIAL, TIPO_ORIGEN.EXTRAJUDICIAL]
